import styled from 'styled-components';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';

import { themeSpace } from 'styles/themeUtils';

export const Row = styled.div`
  width: 100%;
  display: flex;
  border-bottom: 1px solid ${nuDSColor('black', 'defaultT70')};
`;

Row.displayName = 'Row';

export const Column = styled.div`
  padding: ${themeSpace(1)} 0;
  flex: ${({ fullWidth }) => (fullWidth ? 3 : 2)};
  ${({ textAlign }) => textAlign && `
      text-align: ${textAlign};
  `};
`;

Column.displayName = 'Column';
